import { Component, OnInit } from '@angular/core';
import { ClientStyleService } from './services/client-style.service';
import { MessageService } from './services/message.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: []
})

export class AppComponent implements OnInit {
    title = 'Citation Payments';
    public clientKey = '';

    constructor(private _clientStyleService: ClientStyleService, public messageService: MessageService) { }

    ngOnInit(): void {
        this._clientStyleService.loadClientBranding(null).then((value) => {
            this.clientKey = value;
        })
        // this._clientStyleService.loadClientBranding(null);
        // this.clientKey = localStorage.getItem('clientKey');
    }
}
